interface UseUnderwriterProps {
    underwriterName: string;
}

interface UnderwriterSummary {
    uri?: string;
    name: string;
}

const knownFilenames = ['ageas', 'axa', 'covea', 'lv', 'rsa', 'uk_general', 'zurich', 'integra', 'modus', 'aviva', 'tokio_marine', 'prestige', 'lloyds'];

const toSnakeCase = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

const useUnderwriter = ({ underwriterName }: UseUnderwriterProps): UnderwriterSummary => {
    const snake = toSnakeCase(underwriterName);
    const filename = knownFilenames.find((f) => snake.includes(f));
    return filename
        ? { uri: `/img/underwriters/${filename}.png`, name: underwriterName }
        : { name: underwriterName };
};

export default useUnderwriter;
